export default "__VITE_ASSET__kQmnixmJ__"